import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { MdLocationOn, MdEmail, MdPhone } from "react-icons/md";
import logo from "../assets/logo.svg";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src={logo} alt="Vincora" className="navbar__logo-img" />
              <span>Vincora Robotics</span>
            </div>
            <p className="footer__tagline">
              Tarımın geleceğini otonom robotik teknolojileriyle
              şekillendiriyoruz.
            </p>
            <div className="footer__social">
              <a
                href="https://www.linkedin.com/company/vector-roboticss/"
                target="_blank"
                rel="noreferrer"
                className="footer__social-link"
                aria-label="LinkedIn"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
                  <circle cx="4" cy="4" r="2" />
                </svg>
              </a>
            </div>
          </div>

          <div className="footer__col">
            <h4>Sayfalar</h4>
            <ul>
              <li>
                <Link to="/">Ana Sayfa</Link>
              </li>
              <li>
                <Link to="/projects">Projeler</Link>
              </li>
              <li>
                <Link to="/about">Hakkımızda</Link>
              </li>
              <li>
                <Link to="/contact">İletişim</Link>
              </li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>Çözümler</h4>
            <ul>
              <li>
                <a href="/projects">Otonom Hasat Robotları</a>
              </li>
              <li>
                <a href="/projects">Hassas Tarım Sistemleri</a>
              </li>
              <li>
                <a href="/projects">Drone Tabanlı İzleme</a>
              </li>
              <li>
                <a href="/projects">Toprak Analiz Robotları</a>
              </li>
            </ul>
          </div>

          <div className="footer__col">
            <h4>İletişim</h4>
            <ul>
              <li>
                <MdLocationOn
                  size={16}
                  style={{ color: "var(--clr-accent)" }}
                />
                Gaziantep , Türkiye
              </li>
              <li>
                <MdEmail size={16} style={{ color: "var(--clr-accent)" }} />
                vincorarobotics@gmail.com
              </li>
              <li>
                <MdPhone size={16} style={{ color: "var(--clr-accent)" }} />
                +90 (538) 612 29 38
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} Vincora. Tüm hakları saklıdır.</p>
          <p>Tarımda akıllı çözümler için tasarlandı.</p>
        </div>
      </div>
    </footer>
  );
}
